import React, { useEffect } from 'react';
import { SignIn, useAuth } from '@clerk/clerk-react';
import { useSearchParams, Navigate } from 'react-router-dom';

export default function Login() {
  const { isLoaded, isSignedIn } = useAuth();
  const [searchParams] = useSearchParams();
  const searchSlug = searchParams.get('slug');
  const tierParam = searchParams.get('tier');

  // Persist slug across Clerk's nested routes (e.g. email verification)
  // Using localStorage instead of sessionStorage to persist across tabs and browser restarts
  useEffect(() => {
    if (searchSlug) {
      localStorage.setItem('tenantSlug', searchSlug);
    }
  }, [searchSlug]);

  // Capture tier=pro param for users who paid via Stripe Payment Link before logging in
  // This will be used to auto-link their Stripe subscription after login
  useEffect(() => {
    if (tierParam === 'pro') {
      localStorage.setItem('pendingTierLink', 'pro');
    }
  }, [tierParam]);

  const slug = searchSlug || localStorage.getItem('tenantSlug');
  const slugQuery = slug ? `?slug=${slug}` : '';
  const destination = '/';

  if (isLoaded && isSignedIn) {
    return <Navigate to={destination} replace />;
  }

  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-gray-900">Kalibr</h2>
          <p className="mt-2 text-sm text-gray-600">
            LLM Observability Platform
          </p>
        </div>
        <SignIn 
          routing="path" 
          path="/login"
          signUpUrl={`/register${slugQuery}`}
          afterSignInUrl={destination}
          afterSignUpUrl="/welcome"
        />
      </div>
    </div>
  );
}
